import { registerTheme } from '@antv/g2';
const font =
    '"Open Sans", "Segoe UI", Roboto, "Helvetica Neue", Arial,\n    "Noto Sans", sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol",\n    "Noto Color Emoji"';
registerTheme('plxus', {
    fontFamily: font,
    components: {
        axis: {
            common: {
                title: {
                    style: {
                        fontFamily: font,
                        fill: '#000',
                    },
                },
                label: {
                    style: {
                        fontFamily: font,
                        fill: '#000',
                    },
                },
            },

            left: {
                line: { style: { lineWidth: 1, stroke: '#000' } },
            },
            bottom: {
                line: { style: { lineWidth: 1, stroke: '#000' } },
            },
            right: {
                line: { style: { lineWidth: 1, stroke: '#000' } },
            },
            top: {
                position: 'top',

                line: { style: { lineWidth: 1, stroke: '#000' } },
            },
        },

        legend: {
            common: {
                itemName: {
                    style: {
                        fontFamily: font,
                        fill: '#000',
                    },
                },
            },
            continuous: {
                label: {
                    style: {
                        fill: '#000',
                        fontFamily: font,
                    },
                },
            },
        },
        tooltip: {
            domStyles: {
                'g2-tooltip': {
                    color: '#000',
                    fontSize: '12px',
                    fontFamily: font,
                    lineHeight: '12px',
                    padding: '0 12px 0 12px',
                },
            },
        },
        annotation: {
            line: {
                text: {
                    style: {
                        fill: '#000',

                        fontFamily: font,
                    },
                },
                animate: true,
            },
            text: {
                style: {
                    fill: '#000',

                    fontFamily: font,
                },
                animate: true,
            },
            dataMarker: {
                text: {
                    style: {
                        fill: '#000',
                        fontFamily: font,
                    },
                },
            },
            dataRegion: {
                style: {
                    text: {
                        fill: '#000',
                        fontFamily: font,
                    },
                },
            },
        },
    },
    labels: {
        style: {
            fill: '#000',
        },
    },
    grid: {
        line: {
            style: { stroke: '#000' },
        },
    },
});
